import React from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import DashboardNavigation from './dashboard/DashboardNavigation';
import {PublicNavigation} from './public/PublicNavigation';
import {PUBLIC_ROUTES, PUBLIC_ROUTES_PREFIX} from './public/PublicRoutes';
import {CouponNavigation} from './coupon/CouponNavigation';
import {COUPON_ROUTES_PREFIX} from './coupon/CouponRoutes';
import {
  PARTNER_ROUTES_PREFIX,
  PartnerNavigation,
} from './partner/PartnerNavigation';
import {TwitchCon} from '../twitchcon/TwitchCon';
import {PosthogInit} from '../../PosthogInit';
import {
  OVRToolkitRoutes,
  OVR_TOOLKIT_ROUTES_PREFIX,
} from './ovr-toolkit/OVRToolkitRoutes';

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <PosthogInit />
      <Switch>
        <Route path={OVR_TOOLKIT_ROUTES_PREFIX}>
          <OVRToolkitRoutes />
        </Route>
        <Route path={PARTNER_ROUTES_PREFIX}>
          <PartnerNavigation />
        </Route>
        <Route path={PUBLIC_ROUTES_PREFIX}>
          <PublicNavigation />
        </Route>

        {/* TODO: handle public routes without prefix differently */}
        <Route path={PUBLIC_ROUTES.STREAM_REPORT}>
          <PublicNavigation />
        </Route>

        <Route path={COUPON_ROUTES_PREFIX}>
          <CouponNavigation />
        </Route>
        <Route path={'/ui/twitchcon'}>
          <TwitchCon></TwitchCon>
        </Route>
        <Route>
          <DashboardNavigation />
        </Route>
      </Switch>
    </BrowserRouter>
  );
};
